<template lang="html">
    <div>
        <div class="d-flex">
            <!-- Channel -->
            <div class="w-100"><span class="bold">Sales Channel:</span> {{refundChannel(refund)}}</div>
            <!-- Is Request -->
            <div class="w-100"><span class="bold">Is Request:</span> {{refundIsRequest(refund)}}</div>
        </div>

        <div class="d-flex">
            <!-- Payment Method -->
            <div class="w-100"><span class="bold">Payment Method:</span> {{refundPaymentType(refund)}}</div>
            <!-- Type -->
            <div class="w-100"><span class="bold">Type:</span> {{refundType(refund)}}</div>
        </div>

        <div class="d-flex">
            <!-- Reason -->
            <div class="w-100"><span class="bold">Reason:</span> {{refundReason(refund)}}</div>
            <!-- Value -->
            <div v-if="refundValue(refund)" class="w-100"><span class="bold">Value:</span> {{refundValue(refund)}}</div>
        </div>

        <div v-if="treasurerName(refund) || createDate(payment)" class="d-flex">
            <!-- Treasurer -->
            <div v-if="treasurerName(refund)"class="w-100"><span class="bold">Treasurer:</span> {{treasurerName(refund)}}</div>
            <!-- Created On -->
            <div v-if="createDate(payment)" class="w-100"><span class="bold">Created on:</span> {{createDate(payment)}}</div>
        </div>

        <!-- Code -> Only visible by Admin -->
        <!-- <div v-if="refund.code && this.accessPermissionFilter(['admin'])" class="d-flex"> -->
        <div class="d-flex">
            <!-- Code -->
            <div class="w-100" v-if="refund.code"><span class="bold">Code:</span> {{refund.code}}</div>
            <!-- Created On -->
            <div v-if="refundCancelationsReason(refund)" class="w-100"><span class="bold">Reason for refund cancellation: </span> {{refundCancelationsReason(refund)}}</div>
        </div>

        <!-- Refund Items -->
        <div v-if="refund.refundItems.length > 0" class="w-100">
            <span class="bold">Refund items:</span>
            <div>
                <div v-for="refundItem in refund.refundItems" v-if="refundItem.quantity > 0">
                    <div>{{refundItemQtd(refundItem)}}x {{refundItemName(refundItem)}}</div>
                </div>
            </div>
        </div>


        <div class="d-flex justify-content-between my-2">
            <button v-if="shwowCancelBtn" :disabled="isLoading" class="btn action " @click="cancelRefunded(refund)">Cancel this refund</button>
            <button v-if="showExecuteBtn" :disabled="isLoading" class="btn blue btnMarkAsRefunded" @click="markAsRefunded(refund)">Mark as refunded</button>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    data: function () {
        return {
            isLoading: false
        }
    },
    props: {
        refund: {
            tipe: Object,
            default: null,
            required: true
        },
        payment: {
            tipe: Object,
            default: null,
            required: true
        },
        reservation:{
            type: Object
        },
    },
    computed:{
        ...mapGetters([
            'getPaymentTypeListAll',
            'getRefundReasons',
            'getCancelRefundReasons'
        ]),
        shwowCancelBtn: function () {
            return this.showExecuteBtn || !this.refund.id || (this.refund.isRequest && [2,10].includes(this.refund.status))
        },
        showExecuteBtn: function () {
            return  this.refund.id &&
                    this.refund.isRequest == true &&
                    this.refund.isProcessed != true &&
                    this.refund.status == 1 &&
                    ( this.accessPermissionFilter(['admin']) || this.accessPermissionFilter(['mainSupervisor']) )
        },
    },
    methods:{
        ...mapActions([
            'selectRefund',
            'openModal',
            'executeRefund',
        ]),
        refundCancelationsReason: function(refund) {
            if (!refund || !refund.refundCancelationReasonType) {
                return null;
            }
            
            const reason = this.getCancelRefundReasons.find(reason => reason.id === refund.refundCancelationReasonType);
            if (!reason) {
                return null;
            }
            
            const { id, text } = reason;
            const { refundCancelationReasonDescription } = refund;
            
            if (id === 0) {
                return `${text} - ${refundCancelationReasonDescription}`;
            }
            
            return text;
        },
        refundChannel: function (refund) {
            return refund.refundChannels[0].brandName
        },
        refundIsRequest: function (refund) {
            return refund.isRequest? 'Yes' : 'No'
        },
        refundPaymentType: function (refund) {
            let foundPyamentMethod =  this.getPaymentTypeListAll.find(pm => pm.id == refund.paymentType)
            return foundPyamentMethod? foundPyamentMethod.description : ' - '
        },
        refundType: function (refund) {
            if(refund.refundItems.length > 0){
                return !this.refund.isToReleaseQuantity ? 'Reduce Quantity' : 'Reduce Quantity (Available Again)'
            } else if(refund.isToRefundTotal == true){
                return 'Total'
            } else {
                let output = refund.amountType == 0? 'Value' : 'Percentage'
                let value = (refund.amount ) + (refund.amountType == 0? '€' : '%')
                return output + ` (${value})`
            }
        },
        refundReason: function (refund) {
            let reasonId = refund.refundReasonType
            if(reasonId == 0){
                return refund.reason != null ? 'Other: ' + refund.reason : ' - no reason provided -'
            } else {
                let foundReason = this.getRefundReasons.find(r => r.id == reasonId)
                return foundReason? foundReason.text : '-'
            }
        },
        refundValue: function (refund) {
            if(!refund.amountResumeValue){
                return null
            }
            return this.formatPrice(refund.amountResumeValue) + '€'
        },
        refundItemQtd: function (refundItem) {
            return refundItem.quantity
        },
        refundItemName: function (refundItem) {
            if(refundItem.bookingGenderPrice){
                return refundItem.bookingGenderPrice.audienceTypeDescription
            } else if(refundItem.bookingComponent){
                return refundItem.bookingComponent.componentName + ' - ' + refundItem.bookingComponent.componentPriceName
            }
        },
        treasurerName: function (refund) {
            return (refund.userAccount && refund.userAccount.name)? refund.userAccount.name : null
        },
        createDate: function(payment) {
            return payment.createdOn? this.formatDateDots(payment.createdOn) + ' ' + this.formatTime(payment.createdOn) : false
        },
        cancelRefunded: function (refund) {
            if(!refund.id){
                // this means that is a unsaved refund
                this.reservation.refunds = this.reservation.refunds.filter(refund => {
                    return refund.id != undefined
                })
            } else {
                this.selectRefund(refund).then(r => {
                    this.openModal('RefundCancel');
                })
            }
        },
        markAsRefunded: function (refund) {
            this.$dialog.confirm('<h1>Mark as refunded</h1><p class="mt-3">Are your sure you whant to mark as refunded?<br><b>This cannot be undone!</b></p>').then(() => {
                this.isLoading = true
                this.executeRefund({
                    refund: refund,
                    reservation: this.reservation
                }).then(response => {
                    this.isLoading = false
                    this.eventHub.$emit('updateThisReservation', response.data);
                }).catch(err => {
                    this.isLoading = false

                })
            }).catch(function () {
                // This will be triggered when user clicks on cancel
            });
        },
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// refund.vue?e67bb00e